import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import { CustomAlert, showToastAlert } from "../admin/components/CustomAlert";
import "../App.css";
import UserContext from "../context/userContext";
import { fetchCaptchaApi } from "../services/captchaApi";
import { employerRegister } from "../services/employerRegister";
import { isEmailValid } from "../common/commonFunctions";
function SignUp() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [answer, setAnswer] = useState("");
  const [empType, setEmpType] = useState("Select");
  const [captchaHex, setCaptchaHex] = useState("");
  const [captchaImg, setCaptchaImg] = useState("");
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { user, updateUser } = useContext(UserContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCaptcha();
  }, []);

  const fetchCaptcha = async () => {
    try {
      const res = await fetchCaptchaApi();
      if (res) {
        setCaptchaHex(res.hex);
        setCaptchaImg(res.img);
      }
    } catch (error) {
      console.error("Error fetching CAPTCHA", error);
    }
  };

  const validateForm = () => {
    let validationErrors = {};
    if (empType === "Select") {
      validationErrors.empType = "Employer Type is required";
    }
    if (!firstName) validationErrors.firstName = "First Name is required";
    if (!lastName) validationErrors.lastName = "Last Name is required";
    if (!email) validationErrors.email = "Email is required";
    if(isEmailValid(email) === false) validationErrors.email = "Invalid email format";
    if (!password) validationErrors.password = "Password is required";
    if (!answer) validationErrors.answer = "CAPTCHA answer is required";
    if (password.length < 6)
      validationErrors.password = "Password minimum 6 characters";
    setErrors(validationErrors);
    const errorMessages = Object.values(validationErrors);
    if (errorMessages.length > 0) setErrorMessage(errorMessages[0]); // 👈 save the first message
    else setErrorMessage(""); // clear it if no error
    return Object.keys(validationErrors).length === 0;
  };

  const registerEmployer = async () => {
    if (!validateForm()) {
      if (errorMessage) {
        showToastAlert(errorMessage, "error");
      }
      return;
    }
    try {
      const response = await employerRegister(
        email,
        password,
        firstName + " " + lastName,
        answer,
        captchaHex,
        empType
      );
      if (response.status === 200) {
        navigate("/account-created");
      } else {
        showToastAlert(response.data.message, "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Helmet>
        <title >Hire Interns And Freshers | Post Internships | HeyInterns </title>
        <meta name="description" content="Post internships online for free at HeyInterns to hire interns, freshers across 100+ profiles, locations in India. Post your internship requirements today!" />
        <meta property="og:description" content="Post internships online for free at HeyInterns to hire interns, freshers across 100+ profiles, locations in India. Post your internship requirements today!" />
        <meta property="og:image" content="https://heyinterns.com/heyinterns-logo.png" />
      </Helmet>
      <div className="signup-background">
        <img
          src="/heyinterns-signup.jpg"
          alt="Background"
          className="img-fluid mob-banner-image"
        />
        <div className="">
          <div className="signup-form-wrapper">
            <div className="heading-box">
              <h2>Sign Up as Employer</h2>
              <p>Hire early talent with work experience up to 2 years</p>
            </div>
            <Box component="form" noValidate sx={{ mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    onChange={(e) => setFirstName(e.target.value)}
                    size="small"
                    required
                    fullWidth
                    label="First Name"
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                    inputProps={{ maxLength: 25 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    onChange={(e) => setLastName(e.target.value)}
                    size="small"
                    required
                    fullWidth
                    label="Last Name"
                    error={!!errors.lastName}
                    helperText={errors.lastName}
                    inputProps={{ maxLength: 25 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    onChange={(e) => setEmail(e.target.value)}
                    size="small"
                    required
                    fullWidth
                    label="Company Email Address"
                    error={!!errors.email}
                    helperText={errors.email}
                    inputProps={{ maxLength: 50 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    onChange={(e) => setPassword(e.target.value)}
                    size="small"
                    required
                    fullWidth
                    label="Password"
                    type="password"
                    error={!!errors.password}
                    helperText={errors.password}
                    inputProps={{ maxLength: 15 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth size="small" error={!!errors.empType}>
                    <InputLabel id="empType-label">Employer Type</InputLabel>
                    <Select
                      labelId="empType-label"
                      value={empType}
                      onChange={(e) => setEmpType(e.target.value)}
                      label="Employer Type"
                    >
                      <MenuItem value="Select">Select Type</MenuItem>
                      {["startup", "ngo", "company", "college", "freelancer", "other"].map((type) => (
                        <MenuItem key={type} value={type}>
                          {type.charAt(0).toUpperCase() + type.slice(1)}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.empType && (
                      <FormHelperText>{errors.empType}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <img src={captchaImg} alt="CAPTCHA" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    onChange={(e) => setAnswer(e.target.value)}
                    size="small"
                    required
                    fullWidth
                    label="Enter CAPTCHA"
                    error={!!errors.answer}
                    helperText={errors.answer}
                    inputProps={{ maxLength: 15 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label="I want to receive updates via email."
                  />
                </Grid>
              </Grid>
              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={registerEmployer}
              >
                Sign Up
              </Button>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Link to="/student/login" size="small">
                    Already have an account? Sign in
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <h1 className="main-title text-center">
          Introducing <strong> HeyInterns </strong>
        </h1>
        <div className="heading-box">
          <h2>Hire faster, powered by AI</h2>
          <p>
            {" "}
            HeyInterns helps you source, screen, and select top intern talent
            effortlessly. Access 1000+ skilled candidates, filter with expert
            support, and assign tasks to identify the perfect fit — all in one
            smart platform.
          </p>
        </div>

        <div className="row mt-5">
          <div className="col-sm-4">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon2.png" alt="" />
              </figure>
              <h5>✅ Free Resume Assessments</h5>
              <p>
                Quickly identify top talent with our free resume assessments. We
                help you scan through applicants and highlight the most
                promising candidates — saving you time and effort while ensuring
                you don’t miss out on the right fit.
              </p>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon1.png" alt="" />
              </figure>
              <h5>🎯 Job Fit Scoring</h5>
              <p>
                Our smart algorithm evaluates each applicant's resume against
                your internship requirements, providing a Job Fit Score that
                helps you instantly recognize ideal matches. With just a glance,
                you’ll know who’s worth a closer look.
              </p>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon3.png" alt="" />
              </figure>
              <h5>🤝 Help Every Step of the Way</h5>
              <p>
                From posting your internship to selecting the right intern, we
                guide you throughout the process. Our tools are built to make
                hiring easier, faster, and more efficient — because we know
                you’ve got just 31 seconds to find your next star.
              </p>
            </div>
          </div>
        </div>
        <CustomAlert />
      </div>
    </>
  );
}

export default SignUp;
